import DownloadDocumentsSection from "theme/components/contentBlocks/DownloadDocumentsSection";
import PropTypes from "prop-types";
import React from "react";
import activeSetting from "theme/libs/wordpress/utils/activeSetting";
import transformHeading from "../../utils/transformHeading";

const DownloadDocumentsBlock = ({ content, isCustomerService }) => {
    if (!content) {
        return null;
    }

    const { documents, heading, paragraph, settings, tag } = content.data || {};

    const transformedHeading = transformHeading(heading);

    const preparedData = {
        documents: documents || undefined,
        heading: (activeSetting(settings, "heading") && transformedHeading) || undefined,
        paragraph: (activeSetting(settings, "paragraph") && paragraph) || undefined,
        tag: (activeSetting(settings, "tag") && tag) || undefined,
    };

    return <DownloadDocumentsSection {...preparedData} isCustomerService={isCustomerService} />;
};

DownloadDocumentsBlock.propTypes = {
    content: PropTypes.object,
};

DownloadDocumentsBlock.defaultProps = {
    content: {},
};

export default DownloadDocumentsBlock;
